


























import { Component, Prop, Vue } from "@/shared/vuepack";
import HsabExpenseForm from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseForm.vue";
import { HsabExpenseFormMode, HsabExpenseResponse } from "@/shared/types";
import { useThemeStore } from "@/shared/store/theme";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";

@Component({
  components: { GenericLoadingSpinner, HsabExpenseForm }
})
export default class HsabExpenseEditModal extends Vue {
  themeStore = useThemeStore();
  hsabExpenseFormStore = useHsabExpenseFormStore();

  @Prop()
  showModal: boolean;

  get expense (): HsabExpenseResponse {
    return this.hsabExpenseFormStore.expense;
  }

  handleOnEditClose () {
    if (!this.hsabExpenseFormStore.recentlySubmitted) {
      this.hsabExpenseFormStore.updateModalMode(HsabExpenseFormMode.none);
    }
  }
}
